@if (icon()) {
  <fa-icon
    class="font-black"
    [class.px-1.5]="!dense()"
    [icon]="icon()!"
  />
}
